import { useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Plus, Minus } from "lucide-react";

function Item({ c, p, open, onToggle }) {
  return (
    <div data-testid={`pack-component-${c.slug}`} className="border-b border-[var(--line)]">
      <button data-testid={`pack-component-toggle-${c.slug}`} onClick={onToggle} className="flex w-full items-center gap-4 py-4 text-left">
        <img src={p.image} alt={p.name} width="56" height="56" loading="lazy" className="h-14 w-14 shrink-0 rounded-sm object-cover" />
        <span className="flex-1">
          <span className="block font-display text-lg leading-tight">{c.qty > 1 ? `${c.qty} × ` : ""}{p.name}</span>
          {p.volume ? <span className="text-xs text-[var(--muted)]">{p.volume}</span> : null}
        </span>
        {open ? <Minus className="h-4 w-4 text-[var(--gold)]" /> : <Plus className="h-4 w-4 text-[var(--gold)]" />}
      </button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.35 }} className="overflow-hidden">
            <div className="space-y-4 pb-6 pl-[4.5rem] text-sm leading-relaxed text-[var(--parchment)]/85">
              {p.benefits?.length ? <p><span className="eyebrow mr-2">Bienfaits</span>{p.benefits.slice(0, 4).join(" · ")}</p> : null}
              {p.usage ? <p><span className="eyebrow mr-2">Utilisation</span>{p.usage}</p> : null}
              {p.ingredients ? <p data-testid={`pack-component-ingredients-${c.slug}`}><span className="eyebrow mr-2">Composition</span>{p.ingredients}</p> : null}
              <Link to={`/produit/${p.slug}`} className="inline-block text-xs uppercase tracking-[0.2em] text-[var(--gold-soft)] underline-offset-4 hover:underline">Voir la fiche →</Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export function PackComponents({ components, all }) {
  const [open, setOpen] = useState(components[0]?.slug);
  const bySlug = Object.fromEntries((all || []).map((p) => [p.slug, p]));
  const items = components.filter((c) => bySlug[c.slug]);
  if (!items.length) return null;
  return (
    <div data-testid="pack-components">
      {items.map((c) => (
        <Item key={c.slug} c={c} p={bySlug[c.slug]} open={open === c.slug} onToggle={() => setOpen(open === c.slug ? null : c.slug)} />
      ))}
    </div>
  );
}
